import VideoPlayer from './VideoPlayer';

export default VideoPlayer;
export * from './types';
export * from './styles';
export { VideoPlayer };
